import { AddressLink } from './AddressLink';
import { TrackedNativeLink } from './TrackedNativeLink';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  address: Record<string, any>;
  eventName: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties?: Record<string, any>;
};

export function TrackedAddressLink({
  address,
  eventName,
  eventProperties,
}: Props) {
  return (
    <AddressLink
      component={TrackedNativeLink}
      address={address}
      eventName={eventName}
      eventProperties={eventProperties}
    />
  );
}
